var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountSelectedCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V17C18 17.5523 17.5523 18 17 18H1C0.447715 18 0 17.5523 0 17V1ZM13.2039 7.45712C13.5944 7.06659 13.5944 6.43343 13.2039 6.0429C12.8133 5.65238 12.1802 5.65238 11.7897 6.0429L7.99676 9.8358L6.70387 8.5429C6.31334 8.15238 5.68018 8.15238 5.28965 8.5429C4.89913 8.93343 4.89913 9.56659 5.28965 9.95712L7.28965 11.9571C7.68018 12.3476 8.31334 12.3476 8.70387 11.9571L13.2039 7.45712Z",
    fill: "#F65E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSelectedCheckmark);
export default __webpack_public_path__ + "static/media/account-selected-checkmark.b225423fa18c4fd331992066135e92e9.svg";
export { ForwardRef as ReactComponent };